import { SortableWidgetProps } from '@creditsights/styleguide-web';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { cloneElement, ReactElement } from 'react';

interface SortableWidgetWrapperProps {
  children: ReactElement | null;
  id: any;
  isDragButtonDisabled: boolean;
}

const SortableWidgetWrapper = ({
  id,
  children,
  isDragButtonDisabled,
}: SortableWidgetWrapperProps): ReactElement | null => {
  const { setNodeRef, setActivatorNodeRef, listeners, transition, transform, isDragging } = useSortable({ id });

  if (!children) {
    return null;
  }

  const styles = {
    transform: CSS.Transform.toString(transform),
    filter: isDragging ? 'opacity(0.5)' : undefined,
    transition,
  };

  const sortableWidgetProps: SortableWidgetProps = {
    showDragButton: true,
    dragButtonProps: {
      setRef: setActivatorNodeRef,
      listeners,
      isDisabled: isDragButtonDisabled,
      tooltipText: isDragButtonDisabled
        ? 'There needs to be at least 1 widget per column'
        : 'Click and drag to move the widget',
    },
  };

  return (
    <div style={styles} className="sortable-widget" data-testid="sortable-widget">
      {cloneElement(children, {
        ref: setNodeRef,
        ...sortableWidgetProps,
      })}
    </div>
  );
};

export default SortableWidgetWrapper;
